/* Ostria : interactions des sections ostria-*. Sans dependance, chaque module verifie sa presence. */
(() => {
  const EASTERN = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Le theme fait defiler .page-wrapper et non la fenetre.
  const scroller = () => {
    const wrapper = document.querySelector('.page-wrapper');
    return wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1 ? wrapper : document.documentElement;
  };
  const toEastern = (value) => String(value).replace(/[0-9]/g, (digit) => EASTERN[Number(digit)]);

  function sheen(logo, delay = 0) {
    if (reduced || !logo) return;
    setTimeout(() => logo.querySelector('animateTransform')?.beginElement(), delay);
  }

  function initLogos() {
    const header = document.querySelector('.o-logo--header');
    const curtain = document.querySelector('#o-curtain:not([hidden]) .o-logo');
    sheen(curtain, 650);
    sheen(header, curtain ? 1900 : 500);
    sheen(document.querySelector('.o-hero__mark'), 1600);
    header?.closest('a')?.addEventListener('pointerenter', () => sheen(header));
    initLogoHome();
  }

  /* Le logo mene toujours en haut de l'accueil, avec le rideau, depuis n'importe quelle page. */
  function initLogoHome() {
    const curtain = document.getElementById('o-curtain');
    let closing = 0;
    document.querySelectorAll('a.header-logo').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey) return;
        if (!curtain) {
          try {
            sessionStorage.setItem('o-curtain-again', '1');
          } catch {}
          return;
        }
        event.preventDefault();
        const toTop = () => {
          const box = scroller();
          box.scrollTo({ top: 0, behavior: 'instant' });
        };
        if (reduced) {
          toTop();
          return;
        }
        clearTimeout(closing);
        curtain.classList.remove('is-replay');
        curtain.hidden = false;
        void curtain.offsetWidth;
        curtain.classList.add('is-replay');
        sheen(curtain.querySelector('.o-logo'), 420);
        setTimeout(toTop, 360);
        closing = setTimeout(() => {
          curtain.hidden = true;
          curtain.classList.remove('is-replay');
        }, 1750);
      });
    });
  }

  function initReveal() {
    const items = document.querySelectorAll('.o-reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-in'));
      return;
    }
    // Un element entierement masque par clip-path n'intersecte jamais : on observe alors son parent.
    const watched = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          for (const item of watched.get(entry.target)) {
            item.classList.add('is-in');
            if (item.matches('.o-logo')) sheen(item, 1300);
          }
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    items.forEach((item) => {
      const target = getComputedStyle(item).clipPath === 'none' ? item : item.parentElement;
      if (!watched.has(target)) watched.set(target, []);
      watched.get(target).push(item);
      observer.observe(target);
    });
  }

  /* La quantite modifiee met le panier et la barre de progression a jour sans clic supplementaire. */
  function initCartQuantity() {
    document.querySelectorAll('.o-cart__qty input').forEach((input) => {
      input.addEventListener('change', () => input.closest('.o-cart__qty').querySelector('.o-cart__up')?.click());
    });
  }

  /* Compte a rebours reel : il vise le 12 h d'un jour ouvre, limite de la politique d'expedition. */
  function parisDate() {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    const get = (type) => Number(parts.find((part) => part.type === type).value);
    return { year: get('year'), month: get('month'), day: get('day'), seconds: get('hour') * 3600 + get('minute') * 60 + get('second') };
  }

  function isHoliday({ year, month, day }) {
    const fixed = ['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25'];
    if (fixed.includes(`${month}-${day}`)) return true;
    // Paques (calcul de Gauss) puis lundi de Paques, Ascension et lundi de Pentecote.
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const h = (19 * a + b - Math.floor(b / 4) - Math.floor((8 * b + 13) / 25) + 15) % 30;
    const l = (32 + 2 * (b % 4) + 2 * Math.floor(c / 4) - h - c % 4) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const value = h + l - 7 * m + 114;
    const easter = Date.UTC(year, Math.floor(value / 31) - 1, (value % 31) + 1);
    const today = Date.UTC(year, month - 1, day);
    return [1, 39, 50].some((offset) => easter + offset * 86400000 === today);
  }

  // Secondes restantes avant 12 h un jour ouvre, 0 sinon : sert au panier et au concierge.
  function cutoffLeft() {
    const now = parisDate();
    const weekday = new Date(Date.UTC(now.year, now.month - 1, now.day)).getUTCDay();
    const left = 12 * 3600 - now.seconds;
    return left > 0 && weekday > 0 && weekday < 6 && !isHoliday(now) ? left : 0;
  }
  window.ostriaCutoff = cutoffLeft;

  function initCutoff() {
    const items = document.querySelectorAll('[data-o-cutoff]');
    if (!items.length) return;
    const tick = () => {
      const left = cutoffLeft();
      const open = left > 0;
      items.forEach((item) => {
        item.hidden = !open;
        if (open) {
          const hours = Math.floor(left / 3600);
          const minutes = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
          const seconds = String(left % 60).padStart(2, '0');
          item.textContent = `Encore ${hours ? `${hours} h ` : ''}${minutes} min ${seconds} s pour que votre commande soit traitée aujourd’hui`;
        }
      });
      if (open) setTimeout(tick, 1000);
    };
    tick();
  }

  /* Tarifs de livraison lus en direct dans Shopify : le theme suit les reglages sans rien retoucher. */
  const shippingQuery = `mutation($input: CartInput!) { cartCreate(input: $input) { cart { deliveryGroups(first: 1) { nodes { deliveryOptions { title estimatedCost { amount } } } } } } }`;
  let shippingRequest;
  const formatPrice = (amount) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);

  function readShipping() {
    if (shippingRequest) return shippingRequest;
    const variant = document.querySelector('meta[name="ostria-variant"]')?.content;
    let stored = null;
    try {
      stored = JSON.parse(sessionStorage.getItem('o-ship'));
    } catch {}
    if (stored?.length) return (shippingRequest = Promise.resolve(stored));
    if (!variant) return Promise.resolve([]);
    const input = {
      lines: [{ merchandiseId: `gid://shopify/ProductVariant/${variant}`, quantity: 1 }],
      buyerIdentity: {
        countryCode: 'FR',
        deliveryAddressPreferences: [{ deliveryAddress: { address1: '1 rue de Rivoli', city: 'Paris', zip: '75001', country: 'France' } }],
      },
    };
    shippingRequest = fetch('/api/2026-10/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: shippingQuery, variables: { input } }),
    })
      .then((response) => response.json())
      .then((json) => {
        const options = json.data?.cartCreate?.cart?.deliveryGroups?.nodes?.[0]?.deliveryOptions || [];
        const list = options.map((option) => ({ title: option.title, price: formatPrice(option.estimatedCost.amount) }));
        try {
          if (list.length) sessionStorage.setItem('o-ship', JSON.stringify(list));
        } catch {}
        return list;
      })
      .catch(() => []);
    return shippingRequest;
  }
  window.ostriaShipping = readShipping;

  const fillShipText = (scope, list) => {
    if (!list.length) return;
    const sentence = `Au choix à l’étape de paiement : ${list.map((option) => `${option.title}, ${option.price}`).join(' ; ')}.`;
    scope.querySelectorAll('[data-o-ship-text]').forEach((text) => {
      text.textContent = sentence;
    });
  };
  // Le volet du panier remplace son contenu : il redemande les options ici.
  window.ostriaShipText = (scope) => readShipping().then((list) => fillShipText(scope, list));

  function initShipping() {
    const rows = document.querySelectorAll('[data-o-ship-rows]');
    const texts = document.querySelectorAll('[data-o-ship-text]');
    if (!rows.length && !texts.length) return;
    const load = () =>
      readShipping().then((list) => {
        if (!list.length) return;
        rows.forEach((row) => {
          row.replaceWith(
            ...list.map((option) => {
              const item = document.createElement('li');
              const title = document.createElement('span');
              const price = document.createElement('span');
              title.textContent = option.title;
              price.textContent = option.price;
              item.append(title, price);
              return item;
            })
          );
        });
        fillShipText(document, list);
      });
    if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2500 });
    else setTimeout(load, 800);
  }

  /* Les valeurs identiques ne sont pas reecrites : moins de recalcul de style a chaque image. */
  const written = new WeakMap();
  function setVar(element, name, value) {
    let values = written.get(element);
    if (!values) written.set(element, (values = {}));
    if (values[name] === value) return;
    values[name] = value;
    element.style.setProperty(name, value);
  }

  /* Seules les scenes proches de l'ecran gardent une couche graphique et leurs animations actives. */
  function initLive() {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) entry.target.classList.toggle('o-live', entry.isIntersecting);
      },
      { rootMargin: '60% 0px' }
    );
    document.querySelectorAll('[data-o-full], [data-o-dive], [data-o-big], .o-hero').forEach((scene) => observer.observe(scene));
  }

  /* Moteur de scroll : les positions sont mesurees une fois, puis seule la valeur de defilement est lue. */
  const engine = {
    box: document.documentElement,
    top: 0,
    vh: window.innerHeight,
    max: 0,
    items: new Map(),
    track(element) {
      this.items.set(element, { top: 0, height: 0 });
      return element;
    },
    measure() {
      this.box = scroller();
      this.top = this.box.scrollTop;
      this.vh = window.innerHeight;
      this.max = this.box.scrollHeight - this.box.clientHeight;
      for (const [element, data] of this.items) {
        const rect = element.getBoundingClientRect();
        data.top = rect.top + this.top;
        data.height = rect.height;
      }
    },
    at(element) {
      const data = this.items.get(element);
      return { top: data.top - this.top, height: data.height, bottom: data.top - this.top + data.height };
    },
    near(element) {
      const rect = this.at(element);
      return rect.bottom > -this.vh * 0.3 && rect.top < this.vh * 1.3;
    },
  };

  function initWords() {
    const blocks = [...document.querySelectorAll('[data-o-words]')].map((block) => {
      const words = block.textContent.trim().split(/\s+/);
      block.textContent = '';
      const spans = words.map((word, index) => {
        const span = document.createElement('span');
        span.className = 'o-w';
        span.textContent = word;
        block.append(span, index < words.length - 1 ? ' ' : '');
        return span;
      });
      return { block, spans, dive: block.closest('[data-o-dive]'), lit: -1 };
    });
    blocks.forEach((item) => engine.track(item.dive || item.block));
    return () => {
      for (const item of blocks) {
        const owner = item.dive || item.block;
        if (!engine.near(owner)) continue;
        const rect = engine.at(owner);
        let progress;
        if (item.dive) {
          const distance = rect.height - engine.vh;
          const raw = distance > 0 ? -rect.top / distance : 1;
          progress = (raw - 0.42) / 0.5;
        } else {
          progress = (engine.vh * 0.85 - rect.top) / (rect.height + engine.vh * 0.45);
        }
        const lit = Math.round(Math.min(1, Math.max(0, progress)) * item.spans.length);
        if (lit === item.lit) continue;
        const from = Math.min(lit, Math.max(item.lit, 0));
        const to = Math.max(lit, item.lit);
        for (let index = from; index < to; index += 1) item.spans[index].classList.toggle('is-on', index < lit);
        item.lit = lit;
      }
    };
  }

  function initHero() {
    const piece = document.querySelector('.o-hero__piece');
    if (!piece || reduced) return () => {};
    const hero = engine.track(document.querySelector('.o-hero'));
    let last = -1;
    const touch = !window.matchMedia('(pointer: fine)').matches;
    if (touch) {
      let waiting = false;
      window.addEventListener(
        'deviceorientation',
        (event) => {
          if (waiting || event.gamma === null) return;
          waiting = true;
          requestAnimationFrame(() => {
            waiting = false;
            piece.style.setProperty('--o-ty', `${Math.max(-10, Math.min(10, event.gamma / 3)).toFixed(2)}deg`);
          });
        },
        { passive: true }
      );
    } else {
      let queued = false;
      let x = 0.5;
      let y = 0.5;
      window.addEventListener(
        'pointermove',
        (event) => {
          x = event.clientX / window.innerWidth;
          y = event.clientY / window.innerHeight;
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => {
            queued = false;
            piece.style.setProperty('--o-ty', `${((x - 0.5) * 12).toFixed(2)}deg`);
            piece.style.setProperty('--o-tx', `${((0.5 - y) * 8).toFixed(2)}deg`);
            piece.style.setProperty('--o-sun', `${(x * 120 - 40).toFixed(1)}deg`);
          });
        },
        { passive: true }
      );
    }
    return () => {
      if (!engine.near(hero)) return;
      const y = Math.min(engine.top, 900);
      if (y === last) return;
      last = y;
      setVar(piece, '--o-py', `${(y * 0.08).toFixed(1)}px`);
      setVar(piece, '--o-rot', `${(8 - y * 0.012).toFixed(2)}deg`);
      if (touch) setVar(piece, '--o-sun', `${(y * 0.16 + 20).toFixed(1)}deg`);
    };
  }

  function initDive() {
    const sections = [...document.querySelectorAll('[data-o-dive]')].map((element) => engine.track(element));
    return () => {
      for (const section of sections) {
        if (!engine.near(section)) continue;
        const rect = engine.at(section);
        const distance = rect.height - engine.vh;
        const progress = distance > 0 ? Math.min(1, Math.max(0, -rect.top / distance)) : 1;
        setVar(section, '--o-p', progress.toFixed(3));
      }
    };
  }

  function initFull() {
    if (reduced) return () => {};
    const items = [...document.querySelectorAll('[data-o-full]')].map((element) => engine.track(element));
    return () => {
      for (const item of items) {
        if (!engine.near(item)) continue;
        const rect = engine.at(item);
        const travel = (rect.top + rect.height / 2 - engine.vh / 2) / engine.vh;
        const enter = Math.min(1, Math.max(0, 1 - rect.top / engine.vh));
        setVar(item, '--o-shift', `${(travel * -6).toFixed(2)}%`);
        setVar(item, '--o-zoom', (1.08 - enter * 0.08).toFixed(3));
      }
    };
  }

  function initScenes() {
    const big = [...document.querySelectorAll('[data-o-big]')].map((element) => engine.track(element));
    const steps = [...document.querySelectorAll('[data-o-steps]')].map((element) => engine.track(element));
    const cover = document.querySelector('[data-o-cover]');
    if (cover) engine.track(cover);
    if (reduced) {
      steps.forEach((step) => setVar(step, '--o-fill', '1'));
      return () => {};
    }
    return () => {
      const { vh } = engine;
      for (const item of big) {
        if (!engine.near(item)) continue;
        const rect = engine.at(item);
        setVar(item, '--o-big', `${(-(1 - rect.bottom / (vh + rect.height)) * 420).toFixed(1)}px`);
      }
      for (const item of steps) {
        if (!engine.near(item)) continue;
        const rect = engine.at(item);
        const progress = Math.min(1, Math.max(0, (vh * 0.8 - rect.top) / (rect.height + vh * 0.2)));
        setVar(item, '--o-fill', progress.toFixed(3));
      }
      if (cover && engine.near(cover)) {
        setVar(cover, '--o-cov', Math.min(1, Math.max(0, 1 - engine.at(cover).top / vh)).toFixed(3));
      }
    };
  }

  function initProgress() {
    const bar = document.createElement('div');
    bar.className = 'o-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.append(bar);
    let last = '';
    return () => {
      const scale = `scaleX(${engine.max > 0 ? (engine.top / engine.max).toFixed(3) : 0})`;
      if (scale === last) return;
      last = scale;
      bar.style.transform = scale;
    };
  }

  function initScrollLoop() {
    initLive();
    initShipping();
    initCutoff();
    initCartQuantity();
    const pin = initPin();
    const updates = [initDive(), initWords(), initHero(), initFull(), initProgress(), pin.update, initScenes()];
    let queued = false;
    const run = () => {
      queued = false;
      engine.top = engine.box.scrollTop;
      updates.forEach((update) => update());
    };
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(run);
    };
    let pending = false;
    const remeasure = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        pin.measure();
        engine.measure();
        queue();
      });
    };
    document.addEventListener('scroll', queue, { passive: true, capture: true });
    // La barre d'adresse mobile change la hauteur a chaque geste : elle ne justifie pas une remesure.
    let width = window.innerWidth;
    let height = window.innerHeight;
    window.addEventListener(
      'resize',
      () => {
        if (window.innerWidth === width && Math.abs(window.innerHeight - height) < 140) return;
        width = window.innerWidth;
        height = window.innerHeight;
        remeasure();
      },
      { passive: true }
    );
    window.addEventListener('load', remeasure);
    const main = document.getElementById('MainContent');
    if (main && 'ResizeObserver' in window) new ResizeObserver(remeasure).observe(main);
    pin.measure();
    engine.measure();
    run();
  }

  function initDial(root) {
    const svg = root.querySelector('[data-o-dial]');
    if (!svg) return;
    const ns = 'http://www.w3.org/2000/svg';
    const labels = new Map();
    for (let hour = 1; hour <= 12; hour += 1) {
      const angle = (hour * Math.PI) / 6;
      const text = document.createElementNS(ns, 'text');
      text.setAttribute('x', String(200 + Math.sin(angle) * 138));
      text.setAttribute('y', String(200 - Math.cos(angle) * 138));
      text.setAttribute('class', 'o-dial__n');
      text.textContent = toEastern(hour);
      svg.querySelector('[data-o-numbers]').append(text);
      labels.set(hour, text);
    }
    const hands = {
      hour: svg.querySelector('[data-o-hour]'),
      minute: svg.querySelector('[data-o-minute]'),
      second: svg.querySelector('[data-o-second]'),
    };
    const live = root.querySelector('[data-o-live]');
    const tick = () => {
      const now = new Date();
      const seconds = now.getSeconds();
      const minutes = now.getMinutes() + seconds / 60;
      const hours = (now.getHours() % 12) + minutes / 60;
      hands.hour.setAttribute('transform', `rotate(${hours * 30} 200 200)`);
      hands.minute.setAttribute('transform', `rotate(${minutes * 6} 200 200)`);
      hands.second.setAttribute('transform', `rotate(${seconds * 6} 200 200)`);
      if (live) {
        const hh = String(now.getHours()).padStart(2, '0');
        const mm = String(now.getMinutes()).padStart(2, '0');
        live.textContent = `${toEastern(hh)}:${toEastern(mm)}  ·  ${hh}:${mm}`;
      }
    };
    tick();
    setInterval(tick, 1000);

    const chips = [...root.querySelectorAll('[data-o-chip]')];
    const select = (hour) => {
      chips.forEach((chip) => chip.classList.toggle('is-on', Number(chip.dataset.oChip) === hour));
      labels.forEach((label, key) => label.classList.toggle('is-on', key === hour));
    };
    for (const chip of chips) {
      const hour = Number(chip.dataset.oChip);
      chip.addEventListener('click', () => select(hour));
      chip.addEventListener('mouseenter', () => select(hour));
      chip.addEventListener('focus', () => select(hour));
    }

    const input = root.querySelector('[data-o-input]');
    const output = root.querySelector('[data-o-output]');
    if (input && output) {
      const render = () => {
        output.textContent = toEastern(input.value);
      };
      input.addEventListener('input', render);
      render();
    }
  }

  function initAnatomy(root) {
    const items = [...root.querySelectorAll('[data-o-key]')];
    const select = (key) => {
      for (const item of items) {
        const active = item.dataset.oKey === key;
        item.classList.toggle('is-on', active);
        if (item.classList.contains('o-spec')) item.setAttribute('aria-expanded', String(active));
      }
    };
    for (const item of items) item.addEventListener('click', () => select(item.dataset.oKey));
    if (items[0]) select(items[0].dataset.oKey);
  }

  /* Loupe de la fiche : l'image grossit sous le pointeur, sur ordinateur uniquement. */
  function initZoom(root) {
    const stage = root.querySelector('.o-pdp__stage');
    if (!stage || reduced || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    stage.addEventListener('pointerenter', () => stage.classList.add('is-zoom'));
    stage.addEventListener('pointerleave', () => stage.classList.remove('is-zoom'));
    stage.addEventListener('pointermove', (event) => {
      const box = stage.getBoundingClientRect();
      setVar(stage, '--o-zx', `${(((event.clientX - box.left) / box.width) * 100).toFixed(1)}%`);
      setVar(stage, '--o-zy', `${(((event.clientY - box.top) / box.height) * 100).toFixed(1)}%`);
    });
  }

  function initFit(root) {
    const range = root.querySelector('[data-o-range]');
    if (!range) return;
    const value = root.querySelector('[data-o-value]');
    const title = root.querySelector('[data-o-title]');
    const text = root.querySelector('[data-o-text]');
    const wrist = root.querySelector('[data-o-wrist]');
    const verdicts = [
      [15.5, 'Une présence affirmée', 'À ce tour de poignet, les 42 mm se remarquent. La finesse de 10,3 mm garde la montre confortable.'],
      [17.5, 'Un équilibre très porté', 'Les 42 mm occupent bien le poignet sans le dépasser. Le bracelet se règle chez un bijoutier ou un horloger.'],
      [20, 'Votre format idéal', 'Le boîtier est dans ses proportions naturelles : lisible, présent, jamais démesuré.'],
      [99, 'Une montre à votre échelle', 'Les 42 mm restent proportionnés. Vérifiez que la longueur du bracelet convient avant de commander : écrivez-nous, nous vous répondrons.'],
    ];
    const render = () => {
      const cm = Number(range.value);
      value.textContent = `${cm.toFixed(1).replace('.', ',')} cm`;
      const verdict = verdicts.find(([limit]) => cm < limit);
      title.textContent = verdict[1];
      text.textContent = verdict[2];
      // La largeur apparente du poignet vaut environ le tiers de sa circonference.
      wrist.style.setProperty('--o-wrist', ((cm * 10) / 3.1).toFixed(1));
    };
    range.addEventListener('input', render);
    render();
  }

  function initGallery(root) {
    const main = root.querySelector('[data-o-main]');
    const thumbs = [...root.querySelectorAll('[data-o-thumb]')];
    for (const thumb of thumbs) {
      thumb.addEventListener('click', () => {
        thumbs.forEach((item) => item.classList.toggle('is-on', item === thumb));
        main.src = thumb.dataset.oThumb;
        main.classList.toggle('o-pdp__cutout', 'oCut' in thumb.dataset);
      });
    }
  }

  function initCrown(root) {
    const STATES = [
      ['Position normale', 'La couronne est poussée : la montre fonctionne. C’est sa position de tous les jours.', 'Heure', 0],
      ['Réglage de la date', 'Tirez d’un cran, puis tournez dans le sens inverse des aiguilles d’une montre. Repoussez ensuite la couronne.', 'Date', 36],
      ['Réglage de l’heure', 'Tirez de deux crans : la trotteuse s’arrête. Tournez pour placer les aiguilles, puis repoussez : elle repart.', 'Aiguilles', 72],
    ];
    const buttons = [...root.querySelectorAll('[data-o-pos]')];
    const stem = root.querySelector('[data-o-stem]');
    const fn = root.querySelector('[data-o-fn]');
    const title = root.querySelector('[data-o-pt]');
    const text = root.querySelector('[data-o-pd]');
    const select = (index) => {
      const state = STATES[index];
      title.textContent = state[0];
      text.textContent = state[1];
      fn.textContent = state[2];
      stem.style.transform = `translateX(${state[3]}px)`;
      buttons.forEach((button, key) => {
        button.classList.toggle('is-on', key === index);
        button.setAttribute('aria-pressed', String(key === index));
      });
    };
    buttons.forEach((button, key) => button.addEventListener('click', () => select(key)));
    select(0);
    const check = root.querySelector('[data-o-check]');
    const hour = new Date().getHours();
    const time = new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    check.textContent = hour >= 21 || hour < 3
      ? `Il est ${time} : évitez de régler la date maintenant. Attendez après 3 h.`
      : `Il est ${time} : vous pouvez régler la date sans risque.`;
  }

  function initChapters(root) {
    const images = new Map([...root.querySelectorAll('[data-o-img]')].map((img) => [img.dataset.oImg, img]));
    const steps = [...root.querySelectorAll('[data-o-step]')];
    const activate = (step) => {
      steps.forEach((item) => item.classList.toggle('is-on', item === step));
      images.forEach((img, key) => img.classList.toggle('is-on', key === step.dataset.oStep));
    };
    if (steps[0]) activate(steps[0]);
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) if (entry.isIntersecting) activate(entry.target);
      },
      { rootMargin: '-45% 0px -45% 0px' }
    );
    steps.forEach((step) => observer.observe(step));
  }

  function initPin() {
    const desktop = window.matchMedia('(min-width: 901px)');
    const states = [...document.querySelectorAll('[data-o-pin]')].map((section) => ({
      section: engine.track(section),
      track: section.querySelector('[data-o-track-x]'),
      distance: 0,
      loaded: false,
    }));
    return {
      measure() {
        for (const state of states) {
          const { section, track } = state;
          const active = desktop.matches && !reduced;
          section.classList.toggle('is-pinned', active);
          if (!active) {
            section.style.removeProperty('height');
            track.style.removeProperty('transform');
            continue;
          }
          state.distance = Math.max(0, track.scrollWidth - window.innerWidth);
          section.style.height = `${window.innerHeight + state.distance}px`;
        }
      },
      update() {
        for (const state of states) {
          const { section, track, distance } = state;
          const rect = engine.at(section);
          // Les photos sont hors champ horizontalement : on les charge avant l'arrivee de la section.
          if (!state.loaded && rect.top < engine.vh * 2) {
            state.loaded = true;
            track.querySelectorAll('img[loading="lazy"]').forEach((img) => {
              img.loading = 'eager';
            });
          }
          if (!distance || !engine.near(section)) continue;
          const progress = Math.min(1, Math.max(0, -rect.top / distance));
          track.style.transform = `translate3d(${(-progress * distance).toFixed(1)}px, 0, 0)`;
        }
      },
    };
  }

  function initRetract(root) {
    const open = root.querySelector('[data-o-retract-open]');
    const fields = root.querySelector('[data-o-retract-fields]');
    if (!open || !fields) return;
    fields.hidden = true;
    open.addEventListener('click', () => {
      fields.hidden = false;
      open.hidden = true;
      open.setAttribute('aria-expanded', 'true');
      fields.querySelector('input:not([type="hidden"])').focus();
    });
    const ack = root.querySelector('[data-o-ack]');
    const postal = root.querySelector('[data-o-postal]');
    ack.addEventListener('change', () => {
      const needed = ack.value === 'Courrier postal';
      postal.hidden = !needed;
      postal.querySelector('textarea').required = needed;
    });
    root.querySelector('form').addEventListener('submit', () => {
      root.querySelector('[data-o-stamp]').value = new Date().toLocaleString('fr-FR');
    });
  }

  function initCount() {
    const items = document.querySelectorAll('[data-o-count]');
    if (reduced || !items.length) return;
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        const node = entry.target;
        const final = node.textContent;
        const match = final.match(/^(\d+)(,\d+)?(.*)$/);
        if (!match) continue;
        const target = Number(match[1]);
        const start = performance.now();
        const step = (now) => {
          const progress = Math.min(1, (now - start) / 1100);
          const eased = 1 - (1 - progress) ** 3;
          if (progress >= 1) {
            node.textContent = final;
            return;
          }
          node.textContent = `${Math.round(target * eased)}${match[2] || ''}${match[3]}`;
          requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    });
    items.forEach((item) => observer.observe(item));
  }

  function initMagnetic() {
    if (reduced || !window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('.o-btn').forEach((button) => {
      button.addEventListener('pointermove', (event) => {
        const rect = button.getBoundingClientRect();
        const x = (event.clientX - rect.left - rect.width / 2) * 0.1;
        const y = (event.clientY - rect.top - rect.height / 2) * 0.16;
        button.style.translate = `${x.toFixed(1)}px ${y.toFixed(1)}px`;
      });
      button.addEventListener('pointerleave', () => {
        button.style.translate = '';
      });
    });
  }

  function initToc() {
    const toc = document.querySelector('[data-o-toc]');
    const article = document.querySelector('[data-o-article]');
    if (!toc || !article) return;
    const headings = [...article.querySelectorAll('h2')];
    if (headings.length < 3) return;
    const list = toc.querySelector('ol');
    const links = headings.map((heading, index) => {
      heading.id = heading.id || `partie-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link);
      list.append(item);
      return link;
    });
    toc.hidden = false;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const index = headings.indexOf(entry.target);
          links.forEach((link, key) => link.classList.toggle('is-on', key === index));
        }
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    headings.forEach((heading) => observer.observe(heading));
  }

  function initShare() {
    document.addEventListener('click', async (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-o-share]') : null;
      if (!button) return;
      const url = location.origin + location.pathname;
      try {
        if (navigator.share) await navigator.share({ title: button.dataset.title, url });
        else {
          await navigator.clipboard.writeText(url);
          button.textContent = 'Lien copié';
        }
      } catch {
        // Partage annule par le visiteur.
      }
    });
  }

  function initCopy() {
    document.addEventListener('click', async (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-o-copy]') : null;
      if (!button) return;
      const label = button.textContent;
      try {
        await navigator.clipboard.writeText(button.dataset.oCopy);
        button.textContent = 'Code copié';
      } catch {
        button.textContent = button.dataset.oCopy;
      }
      setTimeout(() => {
        button.textContent = label;
      }, 2200);
    });
  }

  function initSticky() {
    const bar = document.querySelector('[data-o-sticky]');
    const hero = document.querySelector('.o-hero, .o-pdp__form');
    const offer = document.querySelector('#offre');
    if (!bar || !hero) return;
    const seen = { hero: true, offer: false };
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) seen[entry.target === hero ? 'hero' : 'offer'] = entry.isIntersecting;
      bar.classList.toggle('is-on', !seen.hero && !seen.offer);
    });
    observer.observe(hero);
    if (offer) observer.observe(offer);
  }

  function init() {
    initLogos();
    initReveal();
    initScrollLoop();
    document.querySelectorAll('[data-o-num]').forEach(initDial);
    document.querySelectorAll('[data-o-ana]').forEach(initAnatomy);
    document.querySelectorAll('[data-o-fit]').forEach(initFit);
    document.querySelectorAll('[data-o-pdp]').forEach(initGallery);
    document.querySelectorAll('[data-o-pdp]').forEach(initZoom);
    document.querySelectorAll('[data-o-crown]').forEach(initCrown);
    document.querySelectorAll('[data-o-chapters]').forEach(initChapters);
    document.querySelectorAll('[data-o-retract]').forEach(initRetract);
    initCount();
    initMagnetic();
    initToc();
    initShare();
    initCopy();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
